import React from 'react';
import TopBanner from '../../MainContents/TopBanner';
import ScrollToTopOnMount from '../../MainContents/AutoScrollTop';  
import WinterTable from '.././Winter/WinterTable';
import LearningDetail from '.././Winter/LearningDetail'
import styled from 'styled-components';


const Comment = styled.div`
    width: 90%;
    margin: auto;
`

const TextColor = styled.a`
    color: #990820;
    font-size: 23px;
`

class Winter extends React.Component {
    render() {
        return (
            <>
                <ScrollToTopOnMount />
                <TopBanner  title="2021年 冬期講座" 
                            text1="君の可能性は無限大　YT教室の冬の陣！"  
                />
                <div class="text-center">
                    <p><TextColor href="https://www.tosajuku.com/news_class/yt_winter2021.pdf" target="_blank">詳細はこちら&ensp;→</TextColor></p>
                </div>
                <div>
                    <WinterTable />
                    <LearningDetail />
                </div>
            
                <Comment className="card mb-3 border-0" >
                        <div className="row g-0">
                            <div className="col-md">
                                <div className="card-body">
                                    <h4 className="card-title font-weight-bold">申込方法</h4>
                                    <h5 className="card-title">当教室に申込用紙がございますので、ご記入のうえ講座料を添えて提出してください。</h5>
                                    <p className="card-text">お電話・メールでのご予約も承ります。</p>
                                    <h5 className="card-text"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                                        </svg>&ensp;(088)813-9007</h5>
                                    <h5 className="card-text">メールでのお問い合わせは<a href="https://www.tosajuku.com/mail/" target="_blank">こちら</a></h5>
                                </div>
                            </div>
                        </div>
                </Comment>
            </>
        );
      }
}

export default Winter;